// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__s-xpY","spin":"styles_spin__ipugx"};